"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateVeloBundlerCacheBuster = exports.generateCacheBuster = void 0;
const generateCacheBuster = () => "cachebuster2";
exports.generateCacheBuster = generateCacheBuster;
const generateVeloBundlerCacheBuster = () => "v3";
exports.generateVeloBundlerCacheBuster = generateVeloBundlerCacheBuster;
//# sourceMappingURL=index.js.map